import FullPageLoader from "components/fullPageLoader"
import { addSpaceEveryNChars, getInvestorsStatus } from "helpers/common"
import useFetchKycData from "hooks/useFetchKycData"
import React, { useEffect } from "react"
import {
  Card,
  Col,
  Row,
  CardBody,
  CardTitle,
  Label,
  Input,
  Container,
} from "reactstrap"

const PersonalInformation = () => {
  const { kycData, isLoading, user, userType, navigate } = useFetchKycData()

  useEffect(() => {
    if (user.entity_type !== "INDIVIDUAL") {
      navigate("/dashboard")
    }
  }, [user])

  return (
    <div className="page-content">
      <Container fluid>
        {isLoading && <FullPageLoader />}

        {!isLoading && user?.status === "APPROVED" && kycData && (
          <div className="mt-4">
            <Card>
              <CardBody className="pt-4">
                <div className="d-flex align-items-center mb-4 justify-content-between ">
                  <CardTitle className="heading-badge">
                    <span> Personal Information</span>
                  </CardTitle>
                  {kycData && (
                    <div className="code-status">
                      {getInvestorsStatus(kycData?.status)}
                    </div>
                  )}
                </div>
                <Row>
                  <Col xl={12}>
                    <Row className="mb-2">
                      <Col xl={6}>
                        <Label className="col-form-label">Name</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsAadhaar?.name}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Date of Birth</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsAadhaar?.dob}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">PAN</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={kycData?.investorsPAN?.pan}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Aadhaar No.</Label>
                        <Input
                          disabled
                          name="name"
                          type="text"
                          className="form-control"
                          value={addSpaceEveryNChars(
                            kycData?.investorsAadhaar?.aadhaar_no
                          )}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Phone No.</Label>
                        <Input
                          disabled
                          name="phone"
                          type="text"
                          className="form-control"
                          value={kycData?.phone}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">Email Address</Label>
                        <Input
                          disabled
                          name="email"
                          type="text"
                          className="form-control"
                          value={kycData?.email}
                        />
                      </Col>
                      <Col xl={6}>
                        <Label className="col-form-label">
                          Political Exposure
                        </Label>
                        <Input
                          disabled
                          name="email"
                          type="text"
                          className="form-control"
                          value={kycData?.additionalDetails?.politicalExposure}
                        />
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </CardBody>
            </Card>
          </div>
        )}
      </Container>
    </div>
  )
}

export default PersonalInformation
